export const WEIGHTED_AVERAGE_AGG_FN_NAME = 'weightedAvg';
export const isWeightedAverageAggregation = (aggFunc) => {
    return (aggFunc === null || aggFunc === void 0 ? void 0 : aggFunc.type) === 'weightedAverage';
};
